<template>
    <div>
        <b-alert v-model="showCasesNotification" dismissible variant="warning">
            There are open or recently closed patient cases:
            <b-link href="#" @click.prevent="handleView">
                Click here to view.
            </b-link>
        </b-alert>

        <b-modal v-model="showCaseModal" title="Cases" size="lg" hide-footer no-fade centered>
            <CasesListComponent :default-items="casesList" small hide-patient show-status :default-page-size="10"
                @update="getCasesForPatient" />
        </b-modal>
    </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import { CaseDetail } from "@/models/Case";
import CasesListComponent from "../Cases/CasesListComponent.vue";
import { NotificationOptions } from "@/util/NotificationOptionsPresets";

@Component({ components: { CasesListComponent } })
export default class PatientCaseBanner extends Vue {

    @Prop({ default: null }) protected patientId!: number | null;
    @Prop({ default: true }) protected showModal!: boolean;

    protected showCasesNotification = false;
    protected casesList: CaseDetail[] = [];
    protected showCaseModal = false;

    mounted() {
        this.getCasesForPatient();
    }

    @Watch("patientId")
    onPatientIdChange() {
        this.getCasesForPatient();
    }

    async getCasesForPatient() {
        if (!this.patientId) {
            this.showCasesNotification = false;
            return;
        }

        try {
            const response = await this.$http.get(`/Patient/${this.patientId}/Cases`);
            this.casesList = response.data;
            this.showCasesNotification = !!this.casesList?.find(c => !c.resolved || moment(c.accepted).isAfter(moment().subtract(7, "days")));
        } catch (error) {
            console.error("Problem loading insurance Patient Cases", error);
            this.$notification(NotificationOptions.error(error));
        }
    }

    handleView() {
        this.$emit('show');
        if (this.showModal) {
            this.showCaseModal = true;
        }
    }
}

</script>

<style scoped>
::v-deep(.alert a) {
    color: black;
}
</style>